import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import Button from "../../../../components/Common/Button";
import {CompanyRmI} from "../../../../db/models/company/rm";
import {openAlert} from "../../../../slices/alert";
import {closeDialog} from "../../../../slices/dialog";
import {addContentDocAndMedia} from "../../../../api/content";

interface Props {
    rm: CompanyRmI;
}

export const AddVideo: React.FC<Props> = ({rm}) => {
    const {register, handleSubmit, errors} = useForm();
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [running, setRunning] = useState(false);

    const onSave = (form) => {
        setRunning(true);
        addContentDocAndMedia(
            form.file[0],
            {
                type: "video",
                rmId: rm.id,
                areaId: rm.areaId,
                companyId: rm.companyId,
                title: form.title,
            }
        )
            .then(() => {
                console.log("evvai");
                setRunning(false);
                dispatch(
                    openAlert({type: "success", message: t("alert_video_uploaded")})
                );
                dispatch(closeDialog());
            })
            .catch((error) => {
                console.error(error);
                setRunning(false);
                dispatch(
                    openAlert({type: "error", message: t("alert_generic_error")})
                );
            });
    };

    useEffect(() => {
        if (!rm) {
            dispatch(closeDialog());
            return;
        }
    }, [rm]);

    return (
        <div className="adminTest">
            <form onSubmit={handleSubmit(onSave)}>
                <fieldset disabled={running}>
                    <div className="element">
                        <div className="label">{t("company_addVideo_title_label")}</div>
                        <input
                            type="text"
                            name="title"
                            ref={register()}
                            placeholder={t("company_addVideo_title_ph")}
                        />
                        {errors.title && (
                            <p className="error">{t("company_addVideo_title_error")}</p>
                        )}
                    </div>
                    <div className="element">
                        <div className="label">File</div>
                        <input
                            type="file"
                            accept=".mp4"
                            name="file"
                            ref={register({required: true})}
                        />
                        {errors.file && (
                            <p className="error">{t("company_addVideo_file_error")}</p>
                        )}
                    </div>
                    <Button type="submit" disabled={running}>
                        Save
                    </Button>
                </fieldset>
            </form>
        </div>
    );
};
